import React          from 'react';
import classnames     from 'classnames';
import connectField   from 'uniforms/connectField';
import filterDOMProps from 'uniforms/filterDOMProps';

import {
  Button,
} from '@sketchpixy/rubix';

const ListAdd = ({
    addIcon,
    className,
    disabled,
    parent,
    value,
    ...props
}) => {
    const limitNotReached = !disabled && !(parent.maxCount <= parent.value.length);

    return (
        <span
            onClick={() => limitNotReached && parent.onChange(parent.value.concat([value]))}
            {...filterDOMProps(props)}
        >
            {addIcon}
        </span>
    );
};

ListAdd.defaultProps = {addIcon: <Button bsStyle="success">Ajouter</Button>};

export default connectField(ListAdd, {includeParent: true, initialValue: false});



/** WEBPACK FOOTER **
 ** ./src/universal/components/fields/ListAddField.js
 **/